export default "__VITE_ASSET__C2dU$Jcc__"